import React from 'react'

const UserCreation = () => {
  return (
    <div>UserCreation</div>
  )
}

export default UserCreation